import React from "react"
import Footer from "./Footer"
import Header from "./Header"

const Layout = ({ children, location }) => {
  return (
    <React.Fragment>
      <Header location={location} microHeader="blue" />
      {children}
      <Footer />
      <div className="hidden !bg-transparent lg:pt-50 lg:pb-185 my-0 lg:pb-30 lg:pt-0 lg:pb-70 lg:pt-70 lg:pb-100 shadow-at-bottom lg:pb-230 lg:pt-150 lg:mt-150 my-40 lg:mb-60 lg:py-140 lg:mb-0 !mb-0 lg:pt-160 lg:my-0 lg:py-50 lg:pb-110 lg:mt-100 lg:mb-50 lg:pb-50 lg:pt-180 lg:!pt-150 lg:py-100 lg:pb-0 lg:pt-10 lg:pb-155 lg:pt-175 lg:pb-180 lg:pt-125 lg:pt-120 lg:pt-200 lg:pb-80 lg:pt-40 lg:py-60 lg:pb-170 lg:pt-100 lg:pb-150 lg:pb-200 !my-0 lg:mb-250 ctm-content lg:!py-100 lg:!pt-135 lg:!pb-90 lg:!pt-100 lg:!pb-80 lg:!mt-30 lg:!py-140 lg:!mb-40 lg:!pt-70 lg:!mt-0 lg:!pt-25 !pt-35 xl:!pt-95 lg:py-120 pt-45 md2:pt-80 lg:pt-105 !pt-0 !mt-0 lg:!mb-0 ctm-heading !bg-white shadow-at-bottom ctm-padding lg:py-150 lg:!pb-85 !pt-30 lg:!pb-40 mdscreen:!pt-30 !pt-20 no-box-shadow ctm-btn ctm-continer-xl ctm-about-arrow"></div>
    </React.Fragment>
  )
}

export default Layout
